// @flow
import * as React from "react";
import cx from "classnames";

import styles from "./Separator.scss";

type SeparatorProps = {
  separatorPosition: "top" | "bottom"
};

const Separator = ({ separatorPosition }: SeparatorProps) => (
  <div
    className={cx(styles.separator, { [styles.separatorTop]: separatorPosition === "top" })}
    data-testid="separator"
  />
);

export default Separator;
